'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent {
  isCollapsed = true;

  constructor(Auth, $state, MENU_CONFIG, PUBLIC_MENU_CONFIG, Config, SettingsService, DynamicPageService) {
    'ngInject';

    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.isSuperAdmin = Auth.isSuperAdminSync;

    this.hasRole = Auth.hasRoleSync;

    this.getCurrentUser = Auth.getCurrentUserSync;
    this.$state = $state;

    this.SettingsService = SettingsService;
    this.DynamicPageService = DynamicPageService;

    this.searchterm = null;
    this.searchSubmitted = false;

    this.menu = MENU_CONFIG.data || [];
    this.publicMenu = PUBLIC_MENU_CONFIG.data || [];

    this.showUserMenuLabel = Config.getModuleConfig(Config.Modules.General).showUserMenuLabel();
    this.userMenuLabel = Config.getModuleConfig(Config.Modules.General).getUserMenuLabel();
    this.defaultMenuPermission = Config.getPlatformConfig().getMenuDefaultPermission();
    this.navbarStyle = Config.getPlatformConfig().getNavbarStyle();
    this.navbarContainer = Config.getPlatformConfig().getNavbarContainer();
    this.navbarInterceptor = Config.getPlatformConfig().getNavbarInterceptor();

    this.hasPaymentsActivated = Config.isModuleEnabled(Config.Modules.Payment);
    this.hasQuickbooksActivated = Config.isModuleEnabled(Config.Modules.Quickbooks);

    this.homeImage = Config.getPlatformConfig().getHomeImage();
    this.homeText = Config.getPlatformConfig().getHomeText();
    this.accountAsMenu = Config.getPlatformConfig().getAccountAsMenu();
    this.accountCustomLabels = Config.getPlatformConfig().getAccountCustomLabels();

    this.signUpDeactivated = Config.getModuleConfig(Config.Modules.SignUp).getDeactivated();

    this.passwordOnlyLogin = Config.getModuleConfig(Config.Modules.SignUp).getPasswordOnlyLogin();
  }

  $doCheck() {
    this.isDigitalSignage = this.$state.current.name == 'digital-signage';
  }

  getPathHome() {
    return (this.isLoggedIn()) ? "/home" : "/";
  }

  hasPermission(menuEntry) {
    let allowedRoles = [];

    if (angular.isArray(menuEntry.permission)) {
      allowedRoles = menuEntry.permission;
    } else if (typeof menuEntry.permission == 'string') {
      allowedRoles = [menuEntry.permission];
    } else if (this.defaultMenuPermission) {
      allowedRoles = [this.defaultMenuPermission];
    } else {
      return false;
    }

    for (let role of allowedRoles) {
      if (this.hasRole(role)) {
        return true;
      }
    }

    return false;
  }

  search(form) {
    this.searchSubmitted = true;

    if(form.$valid) {
      this.searchSubmitted = false;

      if (this.searchterm.startsWith("#")) {

        let splitted = this.searchterm.split(":");

        switch (splitted[0]) {
          case '#sad':
            splitted = ["#s","admin-dashboard"];
            break;
          case '#sarc':
            splitted = ["#s","account-request-config"];
            break;
          case '#sapp':
            splitted = ["#s","config.app"];
            break;
          case '#spf':
            splitted = ["#s","config.platform"];
            break;
          case '#sfp':
            splitted = ["#s","frontpage-settings"];
            break;
          case '#sm':
            splitted = ["#s","menu"];
            break;
          case '#spm':
            splitted = ["#s","public-menu"];
            break;
          case '#fp':
            splitted = ["#p","frontpage-content"];
            break;
          case '#uh':
            splitted = ["#p","user-home"];
            break;
          case '#cpb':
            splitted = ["#cp","page.basic"];
            break;
        }

        switch (splitted[0]) {
          case '#s':
            this.SettingsService.getIdByName({name: splitted[1]}, data => {
              this.$state.go("settings-edit",{id: data._id});
            });
            break;
          case '#p':
            this.DynamicPageService.getIdByName({name: splitted[1]}, data => {
              this.$state.go("dynamic-page-edit",{id: data._id});
            });
            break;
          case '#esl':
          case '#sle':
            this.$state.go("slider-editor");
            break;
          case '#dash':
            this.$state.go("admin-dashboard");
            break;
          case '#mc':
            this.$state.go("mail-composer");
            break;
          case '#ml':
            if (splitted.length == 2) {
              this.$state.go("mail-list",{type: splitted[1]});
            } else {
              this.$state.go("mail-list",{type: 'draft'});
            }
            break;
          case '#ul':
            this.$state.go("admin");
            break;
          case '#ua':
            this.$state.go("upload-archive");
            break;
          case '#cp':
            if (splitted.length == 3) {
              this.$state.go("dynamic-page-edit", {snippet: splitted[1], name: splitted[2]});
            } else if (splitted.length == 2) {
              this.$state.go("dynamic-page-edit",{snippet: splitted[1]});
            } else {
              this.$state.go("dynamic-page-edit");
            }
            break;
          case '#sl':
            this.$state.go("settings-list");
            break;
          case '#svl':
            this.$state.go("survey-list");
            break;
          case '#efl':
            this.$state.go("e-form-list");
            break;
          case '#pl':
            this.$state.go("dynamic-page-list");
            break;
          case '#cpl':
            this.$state.go("admin-page-list");
            break;
          case '#css':
            this.$state.go("style-edit");
            break;
          default:
            this.$state.go('search-result',{searchterm: this.searchterm});
        }

      }
      else {
        this.$state.go('search-result',{searchterm: this.searchterm});
      }

      this.searchterm = "";

    }
  }

}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js